import { combineReducers } from '@reduxjs/toolkit';
import drawerReducer from './drawerReducer';
import authReducer from './authReducer';
import profileReducer from './profileReducer';
import deckReducer from './deckReducer';
import practiceReducer from './practiceReducer';
import scopeReducer from './scopeReducer';
import examReducer from './examReducer';

const rootReducer = combineReducers({
    drawer: drawerReducer,
    auth: authReducer,
    profile: profileReducer,
    deck: deckReducer,
    practice: practiceReducer,
    scope: scopeReducer,
    exam: examReducer,
});

export default rootReducer;
